<section>
    <div class="container">
        <div class="logo-container">
            <img src="assets/version2/logo_dark_word.svg" width="100" alt="Company Logo">
        </div>
        <div style="margin-top: 20px;" *ngFor="let product of IylonProducts" class="product-item">
            <h4 style="font-weight: 600;">{{product.ProductName}}</h4>
            <p class="long-content-section">{{product.Description}}</p>
            <div class="flex-container">
                <label class="inline-label">Cost: ${{product.Cost}}</label>
                <button class="transparent-button" (click)="pay(product.Cost, product.ProductName, product.Id)">
                    PAY
                </button>
            </div>
        </div>
    </div>
</section>
